import React from 'react';
import styled from 'styled-components';
import { strings } from './strings';

const Footer = styled.footer`
  background-color: #111827;
  color: white;
  padding: 3rem 0;
  direction: rtl;
`;

const FooterContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const FooterGrid = styled.div`
  display: grid;
  gap: 2rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FooterSection = styled.div``;

const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const FooterLogoIcon = styled.div`
  width: 2rem;
  height: 2rem;
  background-color: #ea580c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterLogoText = styled.span`
  margin-right: 0.5rem;
  font-size: 1.25rem;
  font-weight: bold;
`;

const FooterDescription = styled.p`
  color: #9ca3af;
  font-size: 0.875rem;
`;

const FooterTitle = styled.h3`
  font-weight: 600;
  margin-bottom: 1rem;
`;

const FooterList = styled.ul`
  font-size: 0.875rem;
  color: #9ca3af;
  
  li {
    margin-bottom: 0.5rem;
    cursor: pointer;
    transition: color 0.2s;
    
    &:hover {
      color: #fb923c;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialIcon = styled.span`
  color: #9ca3af;
  cursor: pointer;
  transition: color 0.2s;
  font-size: 1.25rem;
  
  &:hover {
    color: #fb923c;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #374151;
  margin-top: 2rem;
  padding-top: 2rem;
  text-align: center;
`;

const Copyright = styled.p`
  color: #9ca3af;
  font-size: 0.875rem;
`;

// Footer Component
const FooterComponent = ({ setCurrentPage }) => {
  return (
    <Footer>
      <FooterContainer>
        <FooterGrid>
          <FooterSection>
            <FooterLogo>
              <FooterLogoIcon>
                <span style={{ color: 'white', fontWeight: 'bold' }}>F</span>
              </FooterLogoIcon>
              <FooterLogoText>{strings.global.businessName}</FooterLogoText>
            </FooterLogo>
            <FooterDescription>
              משנים חיים דרך אימון כושר ואורח חיים מותאם אישית.
            </FooterDescription>
          </FooterSection>

          <FooterSection>
            <FooterTitle>קישורים מהירים</FooterTitle>
            <FooterList>
              <li onClick={() => setCurrentPage('home')}>דף הבית</li>
              <li onClick={() => setCurrentPage('process')}>על התהליך</li>
              <li onClick={() => setCurrentPage('home')}>עליי</li>
              <li onClick={() => setCurrentPage('contact')}>צור קשר</li>
            </FooterList>
          </FooterSection>

          <FooterSection>
            <FooterTitle>שירותים</FooterTitle>
            <FooterList>
              <li onClick={() => setCurrentPage('free-gifts')}>מתנות בחינם</li>
              <li onClick={() => setCurrentPage('podcast')}>פודקאסט</li>
              <li onClick={() => setCurrentPage('contact')}>ייעוץ אישי</li>
              <li onClick={() => setCurrentPage('process')}>על התהליך</li>
            </FooterList>
          </FooterSection>

          <FooterSection>
            <FooterTitle>צור קשר</FooterTitle>
            <FooterDescription style={{ marginBottom: '1rem' }}>
              {strings.contact.phone}<br />
              {strings.contact.email}
            </FooterDescription>
            <SocialIcons>
              <SocialIcon>📷</SocialIcon>
              <SocialIcon>📘</SocialIcon>
              <SocialIcon>🐦</SocialIcon>
            </SocialIcons>
          </FooterSection>
        </FooterGrid>

        <FooterBottom>
          <Copyright>
            © 2025 {strings.global.businessName}. כל הזכויות שמורות. | מדיניות פרטיות | תנאי שירות
          </Copyright>
        </FooterBottom>
      </FooterContainer>
    </Footer>
  );
};

export default FooterComponent;